import { createListCollection, Select } from '@chakra-ui/react';
import { HappyHourDiscountType } from '@client/graphql/types/graphql';
import { useTranslate } from '@tolgee/react';

export default function DiscountTypeSelection(props: {
  discountType: HappyHourDiscountType;
  onChange: (discountType: HappyHourDiscountType) => void;
}) {
  const { t } = useTranslate();

  const discountTypeSelection = createListCollection({
    items: [
      {
        label: t(HappyHourDiscountType.Percentage.toString(), HappyHourDiscountType.Percentage.toString()),
        value: HappyHourDiscountType.Percentage,
      },
      {
        label: t(HappyHourDiscountType.Amount.toString(), HappyHourDiscountType.Amount.toString()),
        value: HappyHourDiscountType.Amount,
      },
    ],
  });

  return (
    <Select.Root
      value={[props.discountType]}
      onValueChange={({ value }) => {
        props.onChange(value[0] as HappyHourDiscountType);
      }}
      border={'solid 1px'}
      borderColor={'gray.300'}
      rounded="sm"
      collection={discountTypeSelection}
    >
      <Select.HiddenSelect />
      <Select.Control>
        <Select.Trigger>
          <Select.ValueText px={2} placeholder={t('happy-hour.discount.placeholder', 'Select discount type')} />
        </Select.Trigger>
        <Select.IndicatorGroup>
          <Select.Indicator />
        </Select.IndicatorGroup>
      </Select.Control>
      <Select.Positioner>
        <Select.Content>
          {discountTypeSelection.items.map((discountType) => (
            <Select.Item zIndex={50} item={discountType} key={discountType.value}>
              {discountType.label}
              <Select.ItemIndicator />
            </Select.Item>
          ))}
        </Select.Content>
      </Select.Positioner>
    </Select.Root>
  );
}

